import { render, staticRenderFns } from "./CampusDropDownMenuHeader.vue?vue&type=template&id=40823cf0"
import script from "./CampusDropDownMenuHeader.vue?vue&type=script&lang=js"
export * from "./CampusDropDownMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./CampusDropDownMenuHeader.vue?vue&type=style&index=0&id=40823cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports